var app = angular.module("leonardo");

var GroupAddDialog = function($scope, $rootScope, ngDialog, PropertyGroupService, FormErrorsService, AccountUserService) {

  $scope.mode = $scope.ngDialogData.mode;

  if ($scope.mode === 'edit') {
    var portfolios = [];
    var properties = [];
    angular.forEach($scope.ngDialogData.group.portfolios, function (portfolio) {
      portfolios.push(portfolio.id);
    });
    angular.forEach($scope.ngDialogData.group.properties, function (property) {
      properties.push(property.id);
    });
    $scope.data = {
      name: $scope.ngDialogData.group.name,
      account: $scope.ngDialogData.group.account,
      account_user: $scope.ngDialogData.group.account_user,
      properties_data: {
        portfolios: portfolios,
        properties: properties
      }
    };
  }
  else {
    var account = AccountUserService.currentAccountUser.account;
    if($scope.ngDialogData.account){
      account = $scope.ngDialogData.account.id || $scope.ngDialogData.account;
    }
    $scope.data = {
      account: account,
      account_user: AccountUserService.getAccountUser(account).id
    };
  }

  $scope.clearError = function () {
    if ($scope.Form.name && $scope.Form.name.$error.unique)
      $scope.Form.name.$setValidity('unique', true);
  };

  $scope.getData = function() {
    var data = {
      name: $scope.data.name,
      client_instance: $scope.data.client_instance,
      account: $scope.data.account,
      account_user: $scope.data.account_user
    };
    if ($scope.data.properties_data) {
      data.portfolios = $scope.data.properties_data.portfolios;
      data.properties = $scope.data.properties_data.properties;
    }
    return data;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.mode === 'edit'){
      $scope.ngDialogData.group.patch(data).then(function(group){
        PropertyGroupService.updateCollection(group);
        $rootScope.$broadcast('group:updated', group);
        $scope.closeThisDialog();
      },function(error){
        setValidity(error);
      });
    }
    else {
      PropertyGroupService.post(data).then(function(group) {
        PropertyGroupService.updateCollection(group);
        $rootScope.$broadcast('group:added', group);
        $scope.closeThisDialog();
      },function(error){
        setValidity(error);
      });
    }
  };

  function setValidity(error){
    if (error.data.name){
      $scope.Form.name.$setValidity('unique', false);
    }
  }
};

app.controller('GroupAddDialog', ['$scope', '$rootScope', 'ngDialog', 'PropertyGroupService', 'FormErrorsService',
  'AccountUserService', GroupAddDialog]);
